export const AddendumRoutes = {
  signAddendum: '/addendums/sign/:id',
  getThisAddendumsWithId: '/addendums/get-addendum/:id',
  getThisAddendums: '/addendums/:id',
  getThisSignersAddendum: '/addendums/signers-adendum/:id',
  createAddendumSife: '/addendums/send-adendum-sife',
  createAddendum: '/addendums/create',
  fileAddendum: '/addendums/file',
};
